import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "pad15",
  style: {"height":"280px","width":"400px"}
}
const _hoisted_2 = {
  class: "ofs",
  style: {"height":"280px"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "title mc mt10" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "fw800 fs20 centered",
    style: {"color":"#000"}
  }, "新着メッセージがあります！")
], -1)
const _hoisted_4 = {
  class: "text posRe mt10",
  style: {"color":"#696969"}
}
const _hoisted_5 = {
  key: 0,
  class: "posRe fl mt15"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "posAb",
  style: {"left":"106px","top":"39px"}
}
const _hoisted_8 = {
  class: "posRe fr mt40",
  style: {"width":"140px"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "fs13 fr mt12 mr5 fw600" }, "下にありますチャットより、メッセージをご確認ください", -1)
const _hoisted_10 = { class: "posRe fr" }
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_13 = { class: "w100 centered" }
const _hoisted_14 = {
  class: "centered mc",
  style: {"width":"200px"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: `hideAgain_hideAgain`,
  class: "fs12 fw600 ml5"
}, "今後表示しない", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { style: {"margin-top":"1px"} }, "閉じる", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "NewMessageModal",
    onOpened: _ctx.openModal,
    "content-class": "rad10 yellowBg shadowContent noscroll NewMessageModalContent"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            (_ctx.currentMem)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/notifications/new_messages.png`),
                    width: "220",
                    class: "fl"
                  }, null, 8, _hoisted_6)
                ]))
              : _createCommentVNode("", true),
            (_ctx.currentMem)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_UserIcon, {
                    width: 85,
                    canEdit: false,
                    member: _ctx.currentMem,
                    class: "fl fw600 fs20 pointer",
                    showTooltip: false
                  }, null, 8, ["member"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/notifications/down_arrow.png`),
                  width: "32"
                }, null, 8, _hoisted_11)
              ])
            ]),
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_CheckboxTag, {
                  value: `hideAgain`,
                  name: `hideAgain`,
                  checked: false,
                  prefix: `hideAgain`,
                  class: "mr5",
                  onClickCheckbox: _ctx.hideAgain
                }, null, 8, ["onClickCheckbox"]),
                _hoisted_15
              ]),
              _hoisted_16,
              _createElementVNode("label", {
                class: "centered fs12 pointer circle_button mt10",
                style: {"padding":"5px 8px 3px 8px","border":"1.5px solid #666"},
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
              }, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/close_circle.png`),
                  width: "22",
                  style: {"margin-top":"-2px"}
                }, null, 8, _hoisted_17),
                _hoisted_18
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onOpened"]))
}